export const ANSWER_SET_QUERY = '/assessments/answer-sets/:id';
export const ANSWER_SET_ANSWERS_QUERY = '/assessments/answer-sets/:id/answers';
export const ANSWER_SET_REQUIREMENTS_QUERY = '/assessments/answer-sets/:id/requirements';
export const ANSWER_SET_SCOPING_ANSWERS_QUERY = '/assessments/answer-sets/:id/scoping-answers';
export const START_ANSWER_SET_MUTATION = '/assessments/answer-sets';
export const SWITCH_ACTIVE_ANSWER_SET_MUTATION = '/assessments/active-answer-sets';
